import React from 'react';
import { useNamespacedTranslation } from '../../../../../../hooks/useNamespacedTranslation';

type Props = {
  absenceId: string;
  onClick: (absenceId: string) => void;
};

const MultiDayAbsenceBtn: React.FC<Props> = ({ absenceId, onClick }) => {
  const t = useNamespacedTranslation('absences.absenceDays');

  return (
    <div
      onClick={() => onClick(absenceId)}
      className="d-inline-flex align-items-center link-primary cu-pointer">
      ({t('variableTimes')})
    </div>
  );
};

export default MultiDayAbsenceBtn;
